import { PaymentQuestions } from "./types";

export const PAYMENT_QUESTIONS = {
  isPersonalIban: "speedy_payment.is_personal_iban",
} as const;

export const PAYMENT_QUESTIONS_TRANSLATION_KEYS = {
  isPersonalIban: "speedy_payment.iban_description",
} as const;


export enum QuestionKeys {
  IsPersonalIban = "is-personal-iban",
}

export const QuestionsKeyMap: Record<keyof PaymentQuestions, QuestionKeys> = {
  isPersonalIban: QuestionKeys.IsPersonalIban,
};
